import { render, staticRenderFns } from "./AccountClosingView.vue?vue&type=template&id=15ec8cb0"
import script from "./AccountClosingView.vue?vue&type=script&lang=js"
export * from "./AccountClosingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports